import React from 'react'
import { useContext } from '../Context'
import './Modal.css'

const Modal = ({ children }) => {
    const { globalState, setGlobalState } = useContext()
    const { showModal } = globalState

    if (!showModal) return null

    return (
        <div className={`modal ${showModal ? 'isOpen' : 'isClosed'}`}>
            <div className="modal-content position-relative">
                <div className="close" onClick={() => setGlobalState({ ...globalState, showModal: false })}>&times;</div>
                {children}
            </div>
        </div>
    )
}

export default Modal